import React from "react";
import "../../../CSS/WhyChooseSlash.css"
import SlashCoinsIcon from '../../../Assets/WhyChooseSlashCoinsIcon.png'
import HomeIcon from '../../../Assets/WhyChooseSlashHomeIcon.png'
import VerifiedIcon from '../../../Assets/whyChooseSlashVerifiedIcon.png'
import WhyChooseSlashStoreIcon from '../../../Assets/WhyChooseSlashStoreIcon.png'


const WhyChooseSlash = (selectedServiceTab) => {
    const features = [
  {
    icon: VerifiedIcon,
    title: "Verified Professionals",
    description:
      "Background-verified professionals trusted to deliver quality services at your home.",
  },
  {
    icon: selectedServiceTab == 'at_home' ? HomeIcon : WhyChooseSlashStoreIcon,
    title: selectedServiceTab == 'at_home' ? "Convenience at home" : "Trusted Stores near you",
    description: selectedServiceTab == 'at_home' ? "Slash brings experienced professionals to your doorstep." : "Discover services offered by trusted professionals at verified stores close to you.",
  }
];
  return (
    <div className="why-choose-slash-container-mobile">
      <h2 className="why-choose-slash-title-mobile">Why Choose Slash?</h2>
      <h3 className="why-choose-slash-subtitle-mobile">
        Because finding the right service should feel simple, personal,
        and reliable — every single time.
      </h3>

      <div style={{flexDirection:'row', display:'flex', justifyContent:'space-between', width:'100%',marginTop:10}} >
        {features.map((item, index) => (
          <div className="why-choose-slash-card-mobile" key={index}>
            <img src={item.icon} className="why-choose-slash-icon-mobile" />
            <h3 className="why-choose-slash-card-title-mobile">{item.title}</h3>
            <p className="why-choose-slash-card-description-mobile">{item.description}</p>
          </div>
        ))}
      </div>
      <div style={{marginTop:20, width:'100%',padding:12}} className="why-choose-slash-card-mobile">
        <img src={SlashCoinsIcon} style={{width:60,height:40}}/>
        <h3 className="why-choose-slash-card-title-mobile">Earn Slash Coins with <br/> Every booking</h3>
        <p className="why-choose-slash-card-description-mobile">{"Book services through the Slash app and earn Slash Coins—our way of rewarding you for every completed service."}</p>
      </div>
    </div>
  );
};

export default WhyChooseSlash;
